"use client"

import { ScopeProvider } from "bunshi/react"
import type { PropsWithChildren } from "react"
import {
  BlockchainFiltersScope,
  type BlockchainFiltersState,
} from "./blockchain-filters-scope"

interface Props extends PropsWithChildren {
  initialState: BlockchainFiltersState
}

export function BlockchainFiltersProvider({ children, initialState }: Props) {
  return (
    <ScopeProvider scope={BlockchainFiltersScope} value={initialState}>
      {children}
    </ScopeProvider>
  )
}
